




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class PagingUnit extends Vue {
  @Prop() private queryDataForm: object | undefined;
  @Prop() private total: number | undefined;

  private handleSizeChange(size: number) {
    (this.$parent as any).queryDataForm.pageSize = size;
    (this.$parent as any).getListData();
  }

  private handleCurrentChange(pageNo: number) {
    (this.$parent as any).queryDataForm.pageNo = pageNo;
    (this.$parent as any).getListData();
  }
}
